const compactAxisNumberFormatter = new Intl.NumberFormat(globalThis.navigator.language, {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1,
});

export const formatCompactAxisValue = (value: unknown): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '';
  }

  return compactAxisNumberFormatter.format(value);
};
